import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractApiService } from './abstract-api.service';
import { NGXLogger } from 'ngx-logger';
import { Cer } from '@reenstudio/app/core/models/cer/cer';
import {
  CerAddEditApiRequest,
  CerAddUserApiRequest,
  CerApiPostResponseData,
  CerListApiResponse,
} from '@reenstudio/app/core/models/api/cer/cer-api-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CerService extends AbstractApiService {
  private readonly endpoint = '/cers';

  constructor(
    protected override http: HttpClient,
    protected override logger: NGXLogger
  ) {
    super(http, logger);
  }

  getCers(params?: { cerId?: number; cerName?: string; enabled: boolean }) {
    return this.fetch<CerListApiResponse>(`${this.endpoint}`, params, true);
  }

  getCer(id: number) {
    return this.fetch<Cer>(`${this.endpoint}/${id}`);
  }

  addCer(data: CerAddEditApiRequest): Observable<CerApiPostResponseData> {
    return this.post<CerAddEditApiRequest, CerApiPostResponseData>(
      `${this.endpoint}`,
      data
    );
  }

  addCerUser(userId: string, params: CerAddUserApiRequest) {
    return this.post<CerAddUserApiRequest, string>(
      `/users/${userId}/cer`,
      params
    );
  }

  deleteCerUser(userId: string, params: CerAddUserApiRequest) {
    return this.delete<CerAddUserApiRequest>(`/users/${userId}/cer`);
  }

  editCer(id: number, data: CerAddEditApiRequest) {
    return this.patch<CerAddEditApiRequest, string>(
      `${this.endpoint}/${id}`,
      data
    );
  }

  deleteCer(id: number) {
    return this.delete<number>(`${this.endpoint}/${id}`);
  }
}
